<script setup lang="ts">
import { Enums } from "@/enums";
import { formatDateVerbose } from "../../common/formats.common";

const props = defineProps<{
    status: Enums.InvoiceStatusEnum.Values;
    dueDate: Date;
}>();
</script>

<template>
    <div v-if="props.status === 'U'" class="bg-red-500 rns-badge">
        JATUH TEMPO : {{ formatDateVerbose(props.dueDate).toUpperCase() }}
    </div>
    <div v-if="props.status === 'P'" class="bg-green-500 rns-badge">LUNAS</div>
    <div v-if="props.status === 'C'" class="bg-gray-500 rns-badge">DIBATALKAN</div>
    <div v-if="props.status === 'W'" class="bg-purple-500 rns-badge">LUNAS</div>
</template>

<style scoped>
@reference "@/styles/main.css";

.rns-badge {
    @apply text-white rounded px-2 font-medium;
}
</style>
